// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"Error_modal_body__2_9lx","title":"Error_title__2zdRx","content":"Error_content__3XwTp","icon":"Error_icon__AfI7J"};